import React from 'react';

const TONES = {
  neutral: 'text-fg-dim bg-raised border-line',
  live:    'text-live bg-live-soft border-live/25',
  caution: 'text-caution bg-caution-soft border-caution/25',
  signal:  'text-signal bg-signal-soft border-signal/30',
};

export default function StatusTag({ tone = 'neutral', children, dot = false }) {
  return (
    <span className={`inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full border text-[12px] font-semibold whitespace-nowrap ${TONES[tone]}`}>
      {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" aria-hidden />}
      {children}
    </span>
  );
}
